import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";

/** Link from pañchāṅga / dashboard to Sacred Library topic. */
export function LibraryTopicLink({ to, children, className = "" }) {
  if (!to) return children ?? null;
  return (
    <Link
      to={to}
      className={`inline-flex items-center gap-1 text-primary hover:underline text-sm font-medium ${className}`}
      data-testid="library-topic-link"
    >
      <BookOpen className="w-3.5 h-3.5 shrink-0" />
      {children ?? "Open in Sacred Library"}
    </Link>
  );
}
